<template>
  <div class="contact">
    <b-container class="contact_container">
      <h1 class="pull-left">
        Contact
		<font-awesome-icon icon="handshake" />
        </h1>
      <hr />
      <p class="pull-left">
        Une question, une proposition ? N'hésitez pas, contactez-moi !
      </p>

      <b-form @submit.prevent="onSubmit">
        <b-row>
          <!-- name, email, subject -->
          <b-col lg="6" xl="6" sm="12">
            <!-- NAME -->
            <b-form-group
              id="name-group"
              label=""
              label-for="name"
              description=""
            >
              <b-form-input
                id="name"
                v-model="form.name"
                type="text"
                required
                placeholder="Nom/Entreprise"
                class="form-elmt"
              ></b-form-input>
            </b-form-group>

            <!-- EMAIL -->
            <b-form-group
              id="email-group"
              label=""
              label-for="email"
              description=""
            >
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                required
                placeholder="Adresse email"
                class="form-elmt"
              ></b-form-input>
            </b-form-group>

            <!-- SUBJECT -->
            <b-form-group
              id="subject-group"
              label=""
              label-for="subject"
              description=""
            >
              <b-form-input
                id="subject"
                v-model="form.subject"
                type="text"
                required
                placeholder="Sujet"
                class="form-elmt"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <!-- textarea -->
          <b-col lg="6" xl="6" sm="12">
            <!-- MESSAGE -->
            <b-form-textarea
              id="textarea"
              v-model="form.message"
              placeholder="Message"
              required
              rows="6"
              max-rows="8"
              class="form-elmt"
            >
            </b-form-textarea>
          </b-col>
        </b-row>
        <br />
        <!-- send button -->
        <b-button
          class="send-btn"
          squared
          size="lg"
          :variant="btnVariant"
          type="submit"
          :disabled="isSent"
        >
          <span v-if="!isSending">{{ btnMessage }}</span>
          <b-spinner v-else variant="warning" label="Spinning"></b-spinner>
        </b-button>
      </b-form>
      <br /><br />
    </b-container>
  </div>
</template>

<script>
import MailService from "@/services/MailService";

export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
      isSending: false,
      isSent: false,
      btnMessage: "Envoyer",
      btnVariant: "warning",
      mailService: null,
    };
  },
  mounted() {
    this.mailService = new MailService();
  },
  methods: {
    onSubmit() {
      const { name, email, subject, message } = this.form;
      const payload = {
        //payload to send to mail service
        nom: name,
        mail: email,
        sujet: subject,
        message: message,
      };
      this.isSending = true;
      this.btnVariant = "info";
      setTimeout(() => {
        //fake a timeout
        this.mailService
          .sendContactMail(payload)
          .then(() => {
            //success, edit html
            this.btnVariant = "success";
            this.isSent = true;
            this.btnMessage = "Message envoyé !";
          })
          .catch(() => {
            //fail, edit html
            this.btnVariant = "danger";
            this.btnMessage = "Une erreur s'est produite";
          });
        this.isSending = false;
      }, 700);
    },
  },
};
</script>
